import { useSessionUser } from "hooks/useSession";
import * as React from "react";
import { Skeleton } from "components/common/skeleton/Skeleton";
import { UserAvatarProps } from "./UserAvatar.types";
import { useProfileImage } from "hooks/useProfile/useProfileImage";
import { selectProfileInitials } from "store/selectors/profileSelectors";

export const UserAvatar: React.FC<UserAvatarProps> = ({ className = "", size = "md" }) => {
  const { session: profile } = useSessionUser();
  const initials = selectProfileInitials(profile);
  const { image, hasImagePath, shouldShowImage, onImageError } = useProfileImage();

  const sizeClasses = {
    sm: "w-6 h-6 text-xs",
    md: "w-8 h-8 text-sm",
    lg: "w-10 h-10 text-base",
  };

  const sizeClass = sizeClasses[size];

  if (shouldShowImage) {
    return (
      <img
        src={image.src}
        alt="Profile"
        className={`${sizeClass} rounded-lg object-cover ${className}`}
        onError={onImageError}
      />
    );
  }

  if (hasImagePath && image.isLoading) {
    return <Skeleton className={`${sizeClass} rounded-lg ${className}`} />;
  }

  return (
    <div
      className={`${sizeClass} flex items-center justify-center rounded-lg border border-primary/20 bg-primary/10 font-bold text-primary ${className}`}
    >
      {initials}
    </div>
  );
};
